export default __webpack_public_path__ + "static/media/appStoreRes.fe363add.svg";